import * as React from 'react';
import OfferingListView from "components/Offering/OfferingListView";
import { RouteProps } from 'react-router-dom';
import queryString from 'query-string';

export interface Props extends RouteProps {
    children?: React.ReactNode;
}

export interface State { }


export default class OfferingListPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {
        const values = queryString.parse(this.props?.location?.search);               
    }

    render() {
        return <OfferingListView {...this.props}/>;
    }
}